// /**
//  * Investment tabs and filter functions
//  */
// function panels_on_load() {
//   const first_card = document.querySelector('.m-card--investment-tab');
//   const first_btn = first_card.querySelector('button');

//   first_card.classList.add('active');
//   first_btn.classList.add('active');
//   first_btn.setAttribute('aria-selected', 'true');

//   const panels = document.querySelectorAll('.m-panel');

//   panels.forEach((panel) => {
//     panel.hidden = true;
//   });

//   const matchingPanel = document.querySelector(
//     `.m-panel[aria-labelledby="${first_btn.id}"]`
//   );

//   if (matchingPanel) {
//     matchingPanel.hidden = false;
//   }
// }

// const sfResults = document.querySelector('.search-filter-results');
// if (sfResults) {
//   // Select first tab button and corresponding panel on page load
//   window.addEventListener('load', panels_on_load);

//   // Handle tab button click
//   document.querySelectorAll('.m-card--investment-tab button').forEach((btn) => {
//     btn.addEventListener('click', () => {
//       const clickedBtn = btn;
//       const clickedCard = clickedBtn.closest('.m-card--investment-tab');

//       document.querySelectorAll('.m-card--investment-tab').forEach((card) => {
//         if (card !== clickedCard) {
//           card.classList.remove('active');
//         }
//       });

//       clickedCard.classList.add('active');

//       document
//         .querySelectorAll('.m-card--investment-tab button')
//         .forEach((btn) => {
//           if (btn !== clickedBtn) {
//             btn.classList.remove('active');
//             btn.setAttribute('aria-selected', 'false');
//           }
//         });

//       clickedBtn.classList.add('active');
//       clickedBtn.setAttribute('aria-selected', 'true');

//       const btnId = clickedBtn.id;
//       const matchingPanel = document.querySelector(
//         `.m-panel[aria-labelledby="${btnId}"]`
//       );

//       document.querySelectorAll('.m-panel').forEach((panel) => {
//         panel.hidden = true;
//       });

//       if (matchingPanel) {
//         matchingPanel.hidden = false;
//       }
//     });
//   });

//   // Observe changes and handle tab button click

//   const observer = new MutationObserver(() => {
//     window.removeEventListener('load', panels_on_load);

//     const firstCard = document.querySelector('.m-card--investment-tab');
//     const firstBtn = firstCard.querySelector('button');
//     const matchingPanel = document.querySelector(
//       `.m-panel[aria-labelledby="${firstBtn.id}"]`
//     );

//     firstCard.classList.add('active');
//     firstBtn.classList.add('active');
//     firstBtn.setAttribute('aria-selected', 'true');

//     document.querySelectorAll('.m-panel').forEach((panel) => {
//       panel.hidden = true;
//     });

//     if (matchingPanel) {
//       matchingPanel.hidden = false;
//     }

//     document
//       .querySelectorAll('.m-card--investment-tab button')
//       .forEach((btn) => {
//         btn.addEventListener('click', () => {
//           const clickedBtn = btn;
//           const clickedCard = clickedBtn.closest('.m-card--investment-tab');

//           document
//             .querySelectorAll('.m-card--investment-tab')
//             .forEach((card) => {
//               if (card !== clickedCard) {
//                 card.classList.remove('active');
//               }
//             });

//           clickedCard.classList.add('active');

//           document
//             .querySelectorAll('.m-card--investment-tab button')
//             .forEach((btn) => {
//               if (btn !== clickedBtn) {
//                 btn.classList.remove('active');
//                 btn.setAttribute('aria-selected', 'false');
//               }
//             });

//           clickedBtn.classList.add('active');
//           clickedBtn.setAttribute('aria-selected', 'true');

//           const btnId = clickedBtn.id;
//           const matchingPanel = document.querySelector(
//             `.m-panel[aria-labelledby="${btnId}"]`
//           );

//           document.querySelectorAll('.m-panel').forEach((panel) => {
//             panel.hidden = true;
//           });

//           if (matchingPanel) {
//             matchingPanel.hidden = false;
//           }
//         });
//       });
//   });

//   observer.observe(sfResults, { childList: true, subtree: true });
// }
